const NAMES = [
  "Muharram", "Safar", "Rabiul Awal", "Rabiul Akhir",
  "Jumadil Awal", "Jumadil Akhir", "Rajab", "Syaban",
  "Ramadhan", "Syawal", "Zulkaidah", "Zulhijjah",
];

export function hijriMonthId(month) {
  const n = Number(month?.number);
  return NAMES[n - 1] || month?.en || "";
}
